import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Game from '../scenes/Game';
import UIAssetKeys from '../UIAssetKeys';
import BtnWithText from '../game/BtnWithText';

export default class GameHud extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Game} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene) {
    super(scene);

    this.scene = scene;

    this.btnPhysics = new BtnWithText(this.scene, 76, 71, UIAssetKeys._BtnGo, ABCyaPhaser.Localization.instance.getLocalizedString('go_button'), 48);
    this.add(this.btnPhysics);

    this.btnStack = ABCyaPhaser.Images.addImage(25, 120, UIAssetKeys._BtnStack, this).setInteractive()
      .setOrigin(0);
  }

  updateToggle (isStopped) {
    const sn = isStopped ? UIAssetKeys._BtnStop : UIAssetKeys._BtnGo;
    const text = isStopped ? ABCyaPhaser.Localization.instance.getLocalizedString('stop_button') : ABCyaPhaser.Localization.instance.getLocalizedString('go_button');

    const fontSize = isStopped ? 32 : 48;
    this.btnPhysics.updateButton(sn,text, fontSize);
  }

  activateButtons () {
    this.btnPhysics.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.toggleMoveClick, this);
    this.btnStack.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.stackClick, this);
  }

  toggleMoveClick () {
    const toggle = this.scene.toggleMove();
    this.updateToggle(toggle);
  }

  stackClick () {
    this.updateToggle(false);
    this.scene.stackSnowballs();
  }
}